import {RoleNameEnum} from "../types/common";

export const isClerk = user => user.role.name === RoleNameEnum.CLERK;
export const isResideAdmin = user =>
  user.role.name === RoleNameEnum.RESIDE_ADMIN;
